import cn from 'classnames';
import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import Button from 'components/common/Button';
import { CustomerReportContext } from 'components/grace/Contexts';
import Chat from 'components/icons/grace/Chat';
import useAnalyticsCallback from 'hooks/useAnalyticsCallback';
import { MODAL_TYPES } from 'lib/constants';

const OpenButton = () => {
  const isUserLoaded = useSelector(state => state.user.isLoaded);
  const hasUserCompletedSignup = useSelector(state => state.user.completedSignup);
  const { startReport, setCurrentModal } = useContext(CustomerReportContext);
  const location = useLocation();
  const shouldShiftButton = /\/account\/settings\/privacy-request/.test(location.pathname);

  useEffect(() => {
    window.addEventListener('openGraceModal', handleHomePageClick);
    return () => window.removeEventListener('openGraceModal', handleHomePageClick);
  }, []);

  const handleHomePageClick = useAnalyticsCallback(
    startReport,
    ({ logEvent, events }) => {
      logEvent(events.grace.openModalClicked, { on_homepage: true });
    },
    []
  );

  const handleOnClick = useAnalyticsCallback(
    () => {
      if (isUserLoaded && hasUserCompletedSignup) {
        startReport();
      } else {
        setCurrentModal(MODAL_TYPES.actual_ada);
      }
    },
    ({ logEvent, events }) => {
      logEvent(events.grace.openModalClicked);
    },
    [isUserLoaded]
  );

  const buttonClass = `fixed bottom-4 ${shouldShiftButton ? 'right-24' : 'right-4'} grid grid-cols-2 items-center justify-center rounded-full border-charcoal-60 px-3 py-2 shadow-[0_8px_35px_rgba(0,0,0,0.25)] hover:bg-charcoal-50`;

  return (
    <Button
      ariaLabel="open help chat"
      data-testid="open-help-chat"
      data-authenticated={isUserLoaded}
      className={cn(buttonClass)}
      onClick={handleOnClick}
      variation="Secondary"
    >
      <Chat className="mr-1" />
      <span className="textMd text-secondary">Help</span>
    </Button>
  );
};

export default OpenButton;
